import * as fromShift from '../actions/shift.action';
import {Shift} from '../../shift';

export interface ShiftState {
  entities: Shift[];
  entity: Shift;
  loading: boolean;
  loaded: boolean;
  error: string;
}

export const initialState = {
  entities: null,
  entity: null,
  loading: false,
  loaded: true,
  error: null,
};

export function reducer(state = initialState, action: fromShift.ShiftAction): ShiftState {
  switch (action.type) {
    case fromShift.GET_ALL_SHIFTS: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromShift.GET_ALL_SHIFTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: action.payload,
        error: null
      };
    }
    case fromShift.GET_ALL_SHIFTS_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: null,
        entity: null,
        error: action.payload
      };
    }
    case fromShift.GET_SHIFT: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromShift.GET_SHIFT_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entity: action.payload,
        error: null
      };
    }
    case fromShift.GET_SHIFT_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: null,
        entity: null,
        error: action.payload
      };
    }
  }
  return state;
}




// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/shifts/store/reducers/shift.reducer.ts